import InputCustom from '../atoms/input/InputCustom'
import SelectCustom from '../atoms/select/SelectCustom'
import TextArea from '../atoms/textarea/TextArea'
import DateCustom from '../atoms/input/DateCustom'

const statusOptions = [
	{ label: 'Paid', value: 'paid' },
	{ label: 'Pending', value: 'pending' },
	{ label: 'Cancelled', value: 'cancelled' },
]

export default function AddVendor2({ vendor, setVendor }) {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '12px',
			}}
		>
			<InputCustom
				label="Quote Amount *"
				value={vendor?.quote || ''}
				data={vendor}
				setDataFunction={setVendor}
				type="number"
				id="quote"
				name="quote"
				inputProps={{ min: 0 }}
			/>
			<InputCustom
				label="Deposit Paid"
				value={vendor?.deposit || ''}
				data={vendor}
				setDataFunction={setVendor}
				type="number"
				id="deposit"
				name="deposit"
				inputProps={{ min: 0 }}
			/>
			<DateCustom
				label="Due Date *"
				name="paymentDueDate"
				value={vendor?.paymentDueDate || null}
				data={vendor}
				setDataFunction={setVendor}
				data_cy="vendor-payment-due-date"
			/>
			<div>
				<label htmlFor="status" style={{ font: 'var(--body-font-three)', color: 'var(--secondary-Text)' }}>Status</label>
				<SelectCustom
					label="Status"
					options={statusOptions}
					renderValueAsLabel={true}
					defaultValue={vendor?.status || ''}
					setDataFunction={({ value }) =>
						setVendor((prev) => ({
							...prev,
							status: value,
						}))
					}
				/>
			</div>
			<div>
				<label htmlFor="notes" style={{ font: 'var(--body-font-three)', color: 'var(--secondary-Text)' }}>Notes</label>
				<TextArea
					label="Notes"
					placeholder="Enter Notes"
					value={vendor?.notes || ''}
					onChange={(e) =>
						setVendor((prev) => ({
							...prev,
							notes: e.target.value,
						}))
					}
				/>
			</div>
		</div>
	)
}
